import { Component, OnInit } from '@angular/core';
import { FlagManager } from '../../../../../modules/src/lib/core/managers/flag.manager';
import { FlagEnum } from '../../../../../modules/src/lib/core/enums/flag.enum';
import {
  ClientQuestionnairesClientPortalApiController,
} from '../../../../../modules/src/lib/questionnaires/api-controllers/client-questionnaires.client-portal.api-controller';
import { BehaviorSubject } from 'rxjs';

import { ClientQuestionnaireModel } from '../../../../../../../common/dist/angular/models/client-questionnaire.model';
import { AvailableQuestionnairesStatusEnum } from '../../enums/available-questionnaires-status.enum';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  public availableQuestionnaires: BehaviorSubject<ClientQuestionnaireModel[]> = new BehaviorSubject<ClientQuestionnaireModel[]>([]);

  public availableQuestionnairesStatus: AvailableQuestionnairesStatusEnum = AvailableQuestionnairesStatusEnum.Loading;

  constructor(public readonly authService: AuthService,
              public readonly flagManager: FlagManager,
              public readonly apiController: ClientQuestionnairesClientPortalApiController) {
  }

  get isFileUploadFlagActive() {
    return this.flagManager.isActive(FlagEnum.PortalFileUploads);
  }

  async ngOnInit() {
    const questionnaires = await this.apiController.list();

    this.availableQuestionnaires.next(questionnaires);

    if (questionnaires.length === 0) {
      this.availableQuestionnairesStatus = AvailableQuestionnairesStatusEnum.NoFormsAvailable;
      return;
    }

    this.availableQuestionnairesStatus = AvailableQuestionnairesStatusEnum.FormsAvailable;
  }

}
